import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CountryResponse } from '../dto/response/master.response';

@Injectable({
  providedIn: 'root',
})
export class MasterService {
  constructor(private http: HttpClient) {}

  fetchCountries(): Observable<CountryResponse[]> {
    return this.http
      .get<
        CountryResponse[]
      >(`${environment.baseURL}${environment.MASTER_COUNTRY}`)
      .pipe(finalize(() => {}));
  }
}
